import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { AddMatchLayer } from '../components/Match/AddMatchLayer'

export const AddMatchPage = () => {
  return (
<MasterLayout>
    <AddMatchLayer/>
</MasterLayout> )
}
